/** Central registry of TanStack Query keys, namespaced per feature. */
export const queryKeys = {
  dashboard: {
    stats: () => ["dashboard", "stats"] as const,
    report: (params?: unknown) => ["dashboard", "report", params] as const,
  },
  users: {
    list: (query?: unknown) => ["users", "list", query] as const,
    detail: (id: string) => ["users", "detail", id] as const,
  },
  drivers: {
    list: (query?: unknown) => ["drivers", "list", query] as const,
    detail: (id: string) => ["drivers", "detail", id] as const,
  },
  rides: {
    list: (query?: unknown) => ["rides", "list", query] as const,
    active: () => ["rides", "active"] as const,
    detail: (id: string) => ["rides", "detail", id] as const,
    scheduled: (query?: unknown) => ["rides", "scheduled", query] as const,
  },
  kyc: {
    list: (query?: unknown) => ["kyc", "list", query] as const,
    detail: (id: string) => ["kyc", "detail", id] as const,
  },
  driverChanges: {
    list: (status?: string) => ["driverChanges", "list", status ?? "PENDING"] as const,
  },
  rankings: {
    list: (limit?: number) => ["rankings", "list", limit] as const,
  },
  commission: {
    overview: (params?: unknown) => ["commission", "overview", params] as const,
    settings: () => ["commission", "settings"] as const,
    payouts: (status?: string) => ["commission", "payouts", status ?? "all"] as const,
  },
  pricing: {
    rules: () => ["pricing", "rules"] as const,
  },
  zones: {
    list: () => ["zones", "list"] as const,
  },
  team: {
    admins: () => ["team", "admins"] as const,
    roles: () => ["team", "roles"] as const,
    myPageAccess: () => ["team", "myPageAccess"] as const,
  },
  promos: {
    list: () => ["promos", "list"] as const,
  },
  appVersions: {
    list: () => ["appVersions", "list"] as const,
    history: (app: string) => ["appVersions", "history", app] as const,
  },
  support: {
    list: (query?: unknown) => ["support", "list", query] as const,
    detail: (id: string) => ["support", "detail", id] as const,
    summary: () => ["support", "summary"] as const,
  },
};
